import { readBuffery45c0omfxhxc as readBuffer } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readBuffer(_this__u8e3s4.q5j().d5m(), $completion));
  return SavedHttpCall().m5n(_this__u8e3s4.l5j_1, _this__u8e3s4.o5l(), _this__u8e3s4.q5j(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, request, response, responseBody) {
        return new.target.m5n(client, request, response, responseBody);
      }
      static m5n(client, request, response, responseBody) {
        var $this = this.n5l(client);
        $this.k5n_1 = responseBody;
        $this.n5j_1 = new (SavedHttpRequest())($this, request);
        $this.o5j_1 = new (SavedHttpResponse())($this, $this.k5n_1, response);
        checkContentLength(contentLength(response), fromInt($this.k5n_1.length), request.w5l());
        $this.l5n_1 = true;
        return $this;
      }
      q5l() {
        return this.l5n_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.n5n_1 = origin;
        this.o5n_1 = call;
      }
      v5l() {
        return this.o5n_1;
      }
      ww() {
        return this.n5n_1.ww();
      }
      w5l() {
        return this.n5n_1.w5l();
      }
      x5l() {
        return this.n5n_1.x5l();
      }
      p5l() {
        return this.n5n_1.p5l();
      }
      p2q() {
        return this.n5n_1.p2q();
      }
      u54() {
        return this.n5n_1.u54();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.p5n_1 = call;
        this.q5n_1 = body;
        this.r5n_1 = origin.e5m();
        this.s5n_1 = origin.f5m();
        this.t5n_1 = origin.g5m();
        this.u5n_1 = origin.h5m();
        this.v5n_1 = origin.u54();
        this.w5n_1 = origin.ww();
      }
      v5l() {
        return this.p5n_1;
      }
      e5m() {
        return this.r5n_1;
      }
      f5m() {
        return this.s5n_1;
      }
      g5m() {
        return this.t5n_1;
      }
      h5m() {
        return this.u5n_1;
      }
      u54() {
        return this.v5n_1;
      }
      ww() {
        return this.w5n_1;
      }
      d5m() {
        return ByteReadChannel(this.q5n_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1hc0jjdmqj6mp,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
